import React, { useMemo, type FC } from 'react';
import { styled } from '@compiled/react';
import { Code } from '@atlaskit/code';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

type Props = {
	value?: string;
	issueHierarchyLevel?: number | undefined;
};

export const Header: FC<Props> = ({ value, issueHierarchyLevel }) => {
	const { formatMessage } = useIntl();

	const renderValue = useMemo(
		() =>
			value ||
			formatMessage(messages.defaultPrompt, {
				issueType: issueHierarchyLevel && issueHierarchyLevel > 0 ? 'issues' : 'tasks',
			}),
		[formatMessage, issueHierarchyLevel, value],
	);

	// Using Code component as Tag truncates text
	return (
		<HeaderContainer>
			<Code>
				<PromptValue data-testid="issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.common.header.value">
					{renderValue}
				</PromptValue>
			</Code>
		</HeaderContainer>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HeaderContainer = styled.div({
	padding: token('space.150', '12px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	borderBottom: `1px solid ${token('color.background.accent.gray.subtler', colors.N40)}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const PromptValue = styled.span({
	fontFamily: token('font.family.brand.body', 'sans-serif'),
	fontSize: '14px',
});
